export { default } from "./getAdvisoryDetails";
